import React, { FunctionComponent, useEffect, useState } from 'react'
import { Alert } from 'antd'
import { useBrandContext } from '../../../context/brand'

import DeviceSettings from './DeviceSettings/DeviceSettings'
import AllowPermissionsInstructions from './DeviceSettings/AllowPermissionsInstructions'
import { TMediaConstraints } from '../../../context/types'

type TProps = {
	connectToCall: (constraints: TMediaConstraints) => void
}

let camera: PermissionStatus
let mic: PermissionStatus

const PermissionSettings: FunctionComponent<TProps> = ({ connectToCall }) => {
	const [allowPermissions, setAllowPermissions] = useState<boolean>(null)
	const [permissionError, setPermissionError] = useState<boolean>(false)
	const { brand } = useBrandContext()
	const [constraints, setConstraints] = useState<TMediaConstraints>(null)

	useEffect(() => {
		setDeviceOnchangeHandlers()
		getMedia({ video: true, audio: true })

		return () => {
			removeDeviceOnchangeHandlers()
		}
	}, [])

	useEffect(() => {
		if (constraints?.audio && constraints?.video) {
			setAllowPermissions(true)
			setPermissionError(false)
		} else if (constraints?.audio == false || constraints?.video === false) {
			setPermissionError(true)
		}
	}, [constraints])

	const goToDeviceSettings = () => {
		setAllowPermissions(true)
		setPermissionError(false)
	}

	async function setDeviceOnchangeHandlers() {
		if (navigator.permissions) {
			try {
				camera = await navigator.permissions.query({ name: 'camera' })
				mic = await navigator.permissions.query({ name: 'microphone' })
				camera.onchange = function () {
					getMedia({ video: true, audio: true })
				}
				mic.onchange = function () {
					getMedia({ video: true, audio: true })
				}
			} catch (error) {}
		}
	}

	async function removeDeviceOnchangeHandlers() {
		if (navigator.permissions) {
			try {
				camera.onchange = () => {}
				mic.onchange = () => {}
			} catch (error) {}
		}
	}

	async function getMedia(mediaConstraints: TMediaConstraints) {
		let stream = null
		try {
			stream = await navigator.mediaDevices.getUserMedia(mediaConstraints)

			const audioTrack = stream.getAudioTracks()[0]
			const videoTrack = stream.getVideoTracks()[0]

			audioTrack?.stop()
			videoTrack?.stop()

			const newConstraints = {
				video: !!videoTrack,
				audio: !!audioTrack,
			}

			setConstraints(newConstraints)
			return stream
		} catch (err) {
			setAllowPermissions(false)
			if (mediaConstraints.video && mediaConstraints.audio) {
				getMedia({ video: true, audio: false })
			} else if (mediaConstraints.video) {
				getMedia({ video: false, audio: true })
			} else {
				setConstraints({ video: false, audio: false })
			}
		}
	}

	return (
		<div className="permissions-settings">
			{permissionError && brand.currentBrand && (
				<AllowPermissionsInstructions
					constraints={constraints}
					connectToCall={connectToCall}
					goToDeviceSettings={goToDeviceSettings}
				/>
			)}
			{!permissionError && allowPermissions === false && (
				<Alert showIcon type="info" message="Please, allow access to camera and mic" />
			)}
			{allowPermissions && <DeviceSettings constraints={constraints} connectToCall={connectToCall} />}
		</div>
	)
}

export default PermissionSettings
